import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

export const PrimeVuePreset = definePreset(Lara, {
  primitive: {
    'havel-violet': {
      50: '#c2bed3',
      100: '#b2a9c9',
      200: '#a294bf',
      300: '#9180b5',
      400: '#8073a7',
      500: '#36286d',
      600: '#2b2057',
      700: '#211941',
      800: '#1b1436',
      900: '#120d24',
      950: '#0a0613',
    },
    'brick-red': {
      50: '#fad6d5',
      100: '#f6b4b3',
      200: '#f29190',
      300: '#ed706e',
      400: '#e84f4d',
      500: '#e63331',
      600: '#a12322',
      700: '#7f1c1b',
      800: '#5c1413',
      900: '#3a0d0c',
      950: '#1e0505',
    },
    'markish-green': {
      50: '#b2e4d4',
      100: '#a1dec9',
      200: '#90d7bd',
      300: '#7fd3b7',
      400: '#40b38d',
      500: '#00a770',
      600: '#00744e',
      700: '#00573b',
      800: '#003221',
      900: '#001c12',
      950: '#000d08',
    },
    'spree-blue': {
      50: '#d3e1f2',
      100: '#c1d3eb',
      200: '#a8c4e5',
      300: '#8db3dc',
      400: '#6e9dd4',
      500: '#4d6d94',
      600: '#3f5776',
      700: '#2c3e54',
      800: '#1c2735',
      900: '#0e141b',
      950: '#05080c',
    },
    'electric-yellow': {
      50: '#fdebca',
      100: '#fce2b1',
      200: '#fcd796',
      300: '#fccc79',
      400: '#fabd50',
      500: '#967130',
      600: '#7b5c27',
      700: '#4b3818',
      800: '#2e220f',
      900: '#1b1309',
      950: '#0c0703',
    },
    'dynamic-orange': {
      50: '#f8cdba',
      100: '#f6bca4',
      200: '#f3a88b',
      300: '#f08c5e',
      400: '#ea6a36',
      500: '#ea5b1a',
      600: '#a33f12',
      700: '#7a2f0d',
      800: '#461b07',
      900: '#2a0f04',
      950: '#120501',
    },
    'dark-grey': {
      500: '#343a40',
    },
  },
  semantic: {
    primary: {
      50: '{havel-violet.50}',
      100: '{havel-violet.100}',
      200: '{havel-violet.200}',
      300: '{havel-violet.300}',
      400: '{havel-violet.400}',
      500: '{havel-violet.500}',
      600: '{havel-violet.600}',
      700: '{havel-violet.700}',
      800: '{havel-violet.800}',
      900: '{havel-violet.900}',
      950: '{havel-violet.950}',
    },
    success: {
      500: '{markish-green.500}',
    },
    info: {
      500: '{spree-blue.500}',
    },
    warning: {
      500: '{electric-yellow.500}',
    },
    danger: {
      500: '{brick-red.500}',
    },
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            danger: {
              background: '{brick-red.500}',
            },
          },
        },
      },
    },
    tabs: {
      colorScheme: {
        light: {
          tab: {
            color: '{text.color}',
          },
        },
      },
    },
  },
});
